export default __webpack_public_path__ + "static/media/replayIcon.3eb02cdf.svg";